
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './types';

interface PhoneNumberFieldProps {
  form: UseFormReturn<FormValues>;
  showField: boolean;
}

export const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({ form, showField }) => {
  if (!showField) return null;
  
  return (
    <FormField
      control={form.control}
      name="phoneNumber"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Phone Number (optional)</FormLabel>
          <FormControl>
            <Input placeholder="Your phone number" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
